// import { CountUp } from "use-count-up";
import CountUp from "react-countup";

export const CaseStudyStats = ({ stats = [] }) => {
  const statCount = stats.length;

  return (
    <div
      className={`grid grid-cols-${
        statCount - 1
      } lg:grid-cols-${statCount} bg-white rounded-lg shadow-lg overflow-hidden`}
    >
      {stats.map(({ label, value, type, pre }, index) => {
        const isStat =
          type === "separator" ||
          type === "percentage" ||
          type === "static" ||
          type === "other";
        return (
          <div
            key={index}
            className={`flex flex-col items-center justify-center gap-2 p-4 lg:p-8 border border-gray-200 border-r-1 ${
              type === "heading" && `col-span-${statCount} lg:col-span-1`
            }
            ${stats.length === index + 1 && "col-span-2 lg:col-span-1"}
            `}
          >
            {type === "heading" && (
              <span
                className="text-base font-bold lg:text-xl leading-7 lg:font-extrabold text-gray-link text-center"
                dangerouslySetInnerHTML={{ __html: label }}
              />
            )}
            {isStat && (
              <span className="text-2xl lg:text-5xl font-extrabold leading-none text-red-link">
                {type === "separator" && (
                  <CountUp
                    isCounting
                    end={value}
                    duration={2.5}
                    key={`${value}-${label}`}
                    separator=","
                    delay={index * 0.5}
                  />
                )}
                {type === "percentage" && (
                  <CountUp
                    isCounting
                    end={value}
                    duration={2.5}
                    key={`${value}-${label}`}
                    separator=","
                    suffix="%"
                    delay={index * 0.5}
                  />
                )}
                {type === "static" && (
                  <CountUp
                    isCounting
                    end={value}
                    duration={2.5}
                    key={`${value}-${label}`}
                    delay={index * 0.5}
                  />
                )}
                {type === "other" && (
                  <CountUp
                    isCounting
                    end={value}
                    duration={2.5}
                    key={`${value}-${label}`}
                    delay={index * 0.5}
                    prefix={pre}
                  />
                )}
              </span>
            )}
            {type !== "heading" && (
              <span className="text-sm lg:text-base font-bold leading-6 text-center text-gray-link">
                {label}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};
